// ============================================================================
// vpn/vpnTypes.ts — общие типы пользовательского экрана «Подключения».
// Сервер отдаёт VPN-клиенту только безопасный минимум профиля (без extra и
// технических параметров) — здесь ровно то, что можно показывать человеку.
// ============================================================================

export interface VpnConnectionProfile {
  id: string;
  code: string;
  name: string;
  synonym: string;
  isActive: boolean;
}

export interface VpnClientConfigData {
  profileCode: string;
  protocol: string;
  config: string;
  configFormat: string;
  qrPngBase64: string;
  shareLink: string;
}

/** Человеческое название подключения (синоним → имя). Код в интерфейс
 *  пользователя не выводим — это техническое имя профиля. */
export function vpnConnectionLabel(profile: VpnConnectionProfile): string {
  return profile.synonym || profile.name || 'Подключение';
}
